import { render, staticRenderFns } from "./OfferTemplatePart.vue?vue&type=template&id=00418520&"
import script from "./OfferTemplatePart.vue?vue&type=script&lang=js&"
export * from "./OfferTemplatePart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00418520')) {
      api.createRecord('00418520', component.options)
    } else {
      api.reload('00418520', component.options)
    }
    module.hot.accept("./OfferTemplatePart.vue?vue&type=template&id=00418520&", function () {
      api.rerender('00418520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/offer-template/OfferTemplatePart.vue"
export default component.exports